module["exports"] = [
  "#{street_root}#{street_suffix}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ko/address/street_name.js
 ** module id = 807
 ** module chunks = 0
 **/